import { SxProps, Theme } from '@mui/material';

import { MAX_WIDTH } from '@/config/theme/theme.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

export const appShellStyles: SxProps<Theme> = {
  backgroundColor: themeColors.white,
  border: `1px solid ${themeColors.stroke}`,
  borderRadius: { md: '18px', xs: 0 },
  boxSizing: 'border-box',
  height: '100dvh',
  margin: 'auto',
  maxWidth: MAX_WIDTH,
  minWidth: 0,
  position: 'relative',
  width: '100%',
  zIndex: 1,
};

export const appMainStackStyles: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  width: '100%',
};

export const appOutletStyles: SxProps<Theme> = {
  flex: 1,
  height: '100%',
  minWidth: 0,
  overflow: 'auto',
};
